export enum Branding {
  sixthreezero = "sixthreezero",
  electrified = "electrified",
}
